import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { FormGroupState, validate } from 'ngrx-forms';
import { required } from 'ngrx-forms/validation';
import { FEATURE_NAME } from './zcp-agent-auth-dialog.constant';

export interface ZcpAgentAuthDialogFormValue {
  code: string;
}

export type ZcpAgentAuthDialogFormState = FormGroupState<ZcpAgentAuthDialogFormValue>;

@Injectable({ providedIn: 'root' })
export class ZcpAgentAuthDialogForm extends ZefForm<ZcpAgentAuthDialogFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_NAME,
      {
        code: ''
      },
      {
        code: validate(required)
      }
    );
  }
}
